/* global document */
/* eslint-disable react/no-array-index-key */

// eslint-disable-next-line import/no-cycle
import SideCart from 'cart/SideCart';
import ClubJoinButton from 'club/ClubJoinButton';
import DarioushReceiptWidget from 'club/darioushReceiptWidget/DarioushReceiptWidget';
import Contact from 'forms/contact/Contact';
import Feedback from 'forms/feedback/Feedback';
import FormApp from 'forms/form/App';
import BuyButtonProduct from 'products/BuyButtonProduct';
import BuyButtonSku from 'products/BuyButtonSku';
import Collection from 'products/Collection';
import JordanEventPricing from 'products/JordanEventPricing';
import JordanRequestPricing from 'products/JordanRequestPricing';
import JordanReservationPricing from 'products/JordanReservationPricing';
import QuickShop from 'products/QuickShop';
import QuickShopFF from 'products/QuickShopFF';
import LoginFormWidget from 'profile/LoginFormWidget';
import LoginLogout from 'profile/LoginLogout';
import CreateAccountWidget from 'profile/createAccount/CreateAccountWidget';
import JordanLoyaltyWidget from 'profile/loyaltyTransactions/JordanLoyaltyWidget';
import PersonalizationBlock from 'profile/personalization/PersonalizationBlock';
import Subscribe from 'profile/subscribe/Subscribe';
import AvailabilityWidgetApp from 'reservations/availability/AvailabilityWidgetApp';

const Widgets = () => {
  const login = document.getElementById('c7-login');
  const loginForm = document.getElementById('c7-login-form');
  const cart = document.getElementById('c7-cart');
  const createAccount = document.getElementById('c7-create-account');
  const quickShop = document.getElementById('c7-quick-shop');
  const quickShopff = document.getElementById('c7-quick-shop-ff');
  const reservationTypeDivs = document.getElementsByClassName(
    'c7-reservation-availability'
  );
  const collectionDivs = document.getElementsByClassName(
    'c7-product-collection'
  );
  const personalizationDivs =
    document.getElementsByClassName('c7-personalization');
  const buyButtonDivs = document.getElementsByClassName('c7-buy-variant');
  const subscribeFormDivs = document.getElementsByClassName('c7-subscribe');
  const feedbackForm = document.getElementById('c7-constellation-feedback');
  const contact = document.getElementById('c7-constellation-contact');
  const formDivs = document.getElementsByClassName('c7-form-wrapper');
  const clubJoinButtonDivs = document.getElementsByClassName(
    'c7-club-join-button'
  );
  const loyaltyWidgetJV = document.getElementById('c7-loyalty-widget-jv');
  const eventPricingJV = document.getElementById('c7-event-pricing-jv');
  const requestPricingJV = document.getElementById('c7-request-pricing-jv');
  const reservationPricingJV = document.getElementById(
    'c7-reservation-pricing-jv'
  );
  const darioushReceipt = document.getElementById('c7-darioush-receipt');

  const collections = [];
  [].forEach.call(collectionDivs, (p) => {
    if (p.getAttribute('data-collection-slug')) {
      collections.push({
        node: p,
        collectionSlug: p.getAttribute('data-collection-slug')
      });
    }
  });
  const reservationTypes = [];
  [].forEach.call(reservationTypeDivs, (p) => {
    if (p.getAttribute('data-reservation-type-slug')) {
      reservationTypes.push({
        node: p,
        reservationTypeSlug: p.getAttribute('data-reservation-type-slug')
      });
    }
  });
  const personalizations = [];
  [].forEach.call(personalizationDivs, (node) => {
    if (!node.classList.contains('c7-product-collection-personalization')) {
      if (node.getAttribute('data-block-code')) {
        personalizations.push({
          node,
          code: node.getAttribute('data-block-code')
        });
      }
    }
  });
  const buyButtons = [];
  [].forEach.call(buyButtonDivs, (p) => {
    if (p.getAttribute('data-sku')) {
      buyButtons.push({
        node: p,
        sku: p.getAttribute('data-sku')
      });
    }
    if (p.getAttribute('data-product-slug')) {
      buyButtons.push({
        node: p,
        productSlug: p.getAttribute('data-product-slug')
      });
    }
  });
  const subscribeForms = [];
  [].forEach.call(subscribeFormDivs, (node) => {
    if (!node.classList.contains('c7-subscribe-personalization')) {
      subscribeForms.push({
        node,
        hasNameFields: node.getAttribute('data-has-name-fields'),
        hasZipCode: node.getAttribute('data-has-zip-code')
      });
    }
  });
  const forms = [];
  [].forEach.call(formDivs, (form) => {
    forms.push({
      node: form,
      code: form.getAttribute('data-form-code')
    });
  });
  const clubs = [];
  [].forEach.call(clubJoinButtonDivs, (club) => {
    clubs.push({
      node: club,
      slug: club.getAttribute('data-club-slug'),
      deliveryMethod: club.getAttribute('data-delivery-method')
    });
  });
  return (
    <>
      {cart && <SideCart />}
      {createAccount && (
        <CreateAccountWidget
          redirectTo={createAccount.getAttribute('data-redirect-to')}
        />
      )}
      {login && <LoginLogout />}
      {loginForm && (
        <LoginFormWidget
          redirectTo={loginForm.getAttribute('data-redirect-to')}
        />
      )}
      {feedbackForm && <Feedback />}
      {contact && <Contact />}
      {quickShopff && (
        <QuickShopFF
          collectionSlug={quickShopff.getAttribute('data-collection-slug')}
        />
      )}
      {quickShop && (
        <QuickShop
          collectionSlug={quickShop.getAttribute('data-collection-slug')}
        />
      )}
      {collections.map((product, index) => (
        <Collection
          key={index}
          node={product.node}
          collectionSlug={product.collectionSlug}
        />
      ))}
      {reservationTypes.map((product, index) => (
        <AvailabilityWidgetApp
          key={index}
          node={product.node}
          reservationTypeSlug={product.reservationTypeSlug}
        />
      ))}
      {personalizations.map((personalization, index) => (
        <PersonalizationBlock
          key={index}
          node={personalization.node}
          code={personalization.code}
        />
      ))}
      {buyButtons.map((product, index) => {
        if (product.productSlug) {
          return (
            <BuyButtonProduct
              key={index}
              node={product.node}
              slug={product.productSlug}
            />
          );
        }
        return (
          <BuyButtonSku key={index} node={product.node} sku={product.sku} />
        );
      })}
      {subscribeForms.map((form, index) => (
        <Subscribe
          key={index}
          index={index}
          node={form.node}
          hasNameFields={form?.hasNameFields === 'true' || false}
          hasZipCode={form?.hasZipCode === 'true' || false}
        />
      ))}
      {forms.map((form, index) => (
        <FormApp key={index} index={index} node={form.node} code={form.code} />
      ))}
      {clubs.map((club, index) => (
        <ClubJoinButton
          key={index}
          node={club.node}
          slug={club.slug}
          deliveryMethod={club.deliveryMethod}
        />
      ))}
      {loyaltyWidgetJV && <JordanLoyaltyWidget />}
      {requestPricingJV && (
        <JordanRequestPricing
          slug={requestPricingJV.getAttribute('data-product-slug')}
        />
      )}
      {eventPricingJV && (
        <JordanEventPricing
          slug={eventPricingJV.getAttribute('data-product-slug')}
        />
      )}
      {reservationPricingJV && (
        <JordanReservationPricing
          slug={reservationPricingJV.getAttribute('data-reservation-type-slug')}
        />
      )}
      {darioushReceipt && <DarioushReceiptWidget />}
    </>
  );
};

export default Widgets;
